var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('router-link',{staticClass:"book_link",attrs:{"to":{
      name: "book_detail",
      params: { id: _vm.book.bookCode }
    }}},[_c('img',{attrs:{"src":_vm.book.thumbUrl,"alt":_vm.book.bookNm}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }